module.exports = __webpack_public_path__ + "img/3_72.22c33b16.png";